import React from "react";
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import SubPage from 'components/pages/user/sub-pages';


const UserRoute = ({ user, history }) => {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` }>
                <SubPage.OverView
                    user={ user }
                    history={ history } />
            </Route>
        </Switch>
    );
};

export default UserRoute;